if (!customElements.get('bb-countdown')) {
  customElements.define('bb-countdown', class extends HTMLElement {
    connectedCallback() {
      const end = Date.parse(this.dataset.end);
      if (isNaN(end)) { if (this.parentElement) this.parentElement.hidden = true; return; }
      const pad = (n) => String(n).padStart(2, '0');
      const set = (u, v) => { const el = this.querySelector('[data-unit=' + u + ']'); if (el) el.textContent = pad(v); };
      const tick = () => {
        const diff = end - Date.now();
        if (diff <= 0) {
          clearInterval(this.timer);
          const live = document.createElement('span');
          live.className = 'bb-countdown__live';
          live.textContent = this.dataset.live || '';
          this.replaceChildren(live);
          return;
        }
        const s = Math.floor(diff / 1000);
        set('d', Math.floor(s / 86400));
        set('h', Math.floor((s % 86400) / 3600));
        set('m', Math.floor((s % 3600) / 60));
        set('s', s % 60);
      };
      tick();
      this.timer = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}
